export default function getError(field, errors) {
  if (!errors || !errors[field]) return ''
  if (Array.isArray(errors[field])) {
    return errors[field][0] ?? ''
  }
  return errors[field] ?? ''
}
